import {
  OutputDamageData,
  ErrorResponse,
  FleetRentalData,
  FleetReceiptData,
} from '../../../../@types';

export interface ClaimsState {
  entities: OutputDamageData[] | null;
  display: OutputDamageData[] | null;
  selected: OutputDamageData | null;
  error: ErrorResponse | null;
  totalDamages: number;
  loading: boolean;
  assignableClaimTrips: Array<FleetRentalData> | null;
  claimUserReceipts: Array<FleetReceiptData> | null;
  claimUserReceiptsLoading: boolean;
  isUpdating: boolean;
  isLoadingCarClaim: boolean;
  updatingStatus: boolean;
}

export const initialState = {
  entities: null,
  display: null,
  selected: null,
  assignableClaimTrips: null,
  claimUserReceipts: null,
  claimUserReceiptsLoading: false,
  error: null,
  totalDamages: 0,
  loading: false,
  isUpdating: false,
  isLoadingCarClaim: false,
  updatingStatus: false,
};
